import { useTranslation } from 'react-i18next';
import { useProvider } from '../../../hooks/useProvider';
import { Spinner } from '../../shadcn/Spinner';
import { UniLoginLayout } from './screen-layout';

/** Before the UniLogin request exists (`detecting` false), then while the extension is being looked for. */
export function UniLoginLoading({ detecting }: { detecting: boolean }) {
  const { t } = useTranslation();
  const { provider_name } = useProvider();

  return (
    <UniLoginLayout>
      <div className="text-muted-foreground flex flex-col items-center gap-4 text-center text-sm">
        <Spinner />
        <span>
          {t(detecting ? 'LoginScreen.unilogin.detecting' : 'LoginScreen.unilogin.preparing', {
            ns: 'translation',
            provider: provider_name,
          })}
        </span>
      </div>
    </UniLoginLayout>
  );
}
